var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHatchef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#009cde;}.cls-3{fill:#0a74b9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ricetta_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37,
    cy: 37,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,74A37,37,0,1,1,74,37,37,37,0,0,1,37,74ZM37,4A33,33,0,1,0,70,37,33,33,0,0,0,37,4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2254-2",
    "data-name": "Tracciato 2254-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.35,54.36H23.73V44.92a9,9,0,0,1-2-.5A9.33,9.33,0,0,1,27,26.55a10.89,10.89,0,0,1,20.18,0A9,9,0,0,1,54.3,28a9.77,9.77,0,0,1,4,7.69,9.34,9.34,0,0,1-7.93,9.22Zm-23.82-2.8h21V42.22H49a6.54,6.54,0,0,0,6.53-6.53,6.92,6.92,0,0,0-2.82-5.42,6.35,6.35,0,0,0-6-.69l-1.41.47-.38-1.45a8.1,8.1,0,0,0-15.67,0l-.39,1.51-1.46-.55A6.53,6.53,0,0,0,22.76,41.8a6.71,6.71,0,0,0,2.27.42h1.5Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchef);
export default __webpack_public_path__ + "static/media/hatchef.b65b156aade0cbe779819be5c068b00b.svg";
export { ForwardRef as ReactComponent };